/* eslint-disable no-underscore-dangle */
/** 一小时后刷新；普通缓存读取最多复用到四十八小时。 */
export const blackBoxStorageTime = 60 * 60 * 1000;
export const blackBoxMaxAge = 48 * blackBoxStorageTime;
export const validBlackBoxMaxLength = 1024;
export const degradedBlackBoxMaxLength = 5000;

const sdk = window.TONGDun || (window.TONGDun = {});
/** tongdun.js 与公共库分开加载，页面内共用这一份采集结果。 */
export const cache = sdk._blackBoxCache || (sdk._blackBoxCache = {
  value: '', time: 0, stored: false, cleared: false, generation: 0
});


/**
 * 解析调用方可接受的长度，保留已有 maxLength 优先级。
 * @param {Object|boolean=} options 取值配置
 * @returns {number} 最大长度
 */
export const getAllowedBlackBoxMaxLength = (options) => {
  const maxLength = options && options !== true ? Number(options.maxLength) : 0;
  if (maxLength > 0) {
    return maxLength;
  }
  return options === true || (options && options.allowDegraded) ? degradedBlackBoxMaxLength : validBlackBoxMaxLength;
};

/** 判断当前传输场景能否使用该值。 */
export const isValidBlackBox = (value, options) => typeof value === 'string' && value.length > 0 && value.length <= getAllowedBlackBoxMaxLength(options);

/** 校验缓存保存时间；缺少可信时间时沿用已有缺时间诊断。 */
const getCacheTimeReason = (time, now, maxAge) => {
  const age = now - time;
  if (!Number.isFinite(time) || time <= 0 || age < 0) {
    return 'td_storage_time_missing';
  }
  return age >= maxAge ? 'td_storage_expired' : '';
};

/**
 * 统一清理内存及持久化值；主动 clear 时同时废弃旧 App 回调。
 * @param {boolean=} invalidate 是否废弃之前的异步取值
 * @returns {string} 清理失败原因，成功时为空
 */
export const clearBlackBox = (invalidate = false) => {
  cache.value = '';
  cache.time = 0;
  cache.stored = false;
  cache.cleared = true;
  if (invalidate) {
    cache.generation += 1;
  }
  let reason = '';
  for (let index = 0; index < 2; index += 1) {
    try {
      localStorage.removeItem(index ? 'tongdunBlackBox' : 'tongdunAbleTime');
    } catch (error) {
      reason = 'td_storage_remove_error';
    }
  }
  cache.cleared = !!reason;
  return reason;
};

/**
 * 先保留采集结果，再尝试持久化，存储失败不丢失本页可用值。
 * @param {string} value 已通过 SDK 长度校验的值
 * @param {number} time 实际采集完成时间，读取缓存时不能刷新它
 * @returns {string} 存储失败原因，成功时为空
 */
export const saveBlackBox = (value, time) => {
  cache.value = value;
  cache.time = time;
  cache.stored = false;
  cache.cleared = false;
  try {
    // 先写值，避免第二次写入失败时给旧值配上新的保存时间。
    localStorage.setItem('tongdunBlackBox', value);
    localStorage.setItem('tongdunAbleTime', time);
    cache.stored = true;
    return '';
  } catch (error) {
    return 'td_storage_set_error';
  }
};

/**
 * 读取缓存；仅在存储受限或本轮写入失败时采用未过期的内存值。
 * @param {boolean} checkExpired 是否使用一小时取值上限；否则仍检查四十八小时硬上限
 * @param {Object|boolean=} options 长度配置
 * @param {Object=} read 本次读取的诊断；readTime 用于初始化时读取缓存时间
 * @returns {string} 当前场景可使用的 black_box
 */
export const readBlackBox = (checkExpired = false, options, read) => {
  const maxAge = checkExpired ? blackBoxStorageTime : blackBoxMaxAge;
  const now = Date.now();
  let value = '';
  let time = 0;
  let reason = '';
  let storageLength = 0;
  if (!cache.cleared) {
    try {
      value = localStorage.getItem('tongdunBlackBox') || '';
      storageLength = value.length;
      // 其他调用方已删除或替换持久化值时，不恢复旧内存值。
      if (cache.stored && value !== cache.value) {
        cache.value = '';
      }
      if (value || checkExpired || (read && read.readTime)) {
        time = Number(localStorage.getItem('tongdunAbleTime'));
      }
      if (value || checkExpired) {
        reason = getCacheTimeReason(time, now, maxAge);
        if (reason) { value = '' }
      }
    } catch (error) {
      value = '';
      reason = 'td_storage_get_error';
    }
    if ((reason === 'td_storage_get_error' || !cache.stored) && cache.value) {
      // 内存值不符合当前长度限制时，保留已读取的可用缓存。
      if (!getCacheTimeReason(cache.time, now, maxAge) && isValidBlackBox(cache.value, options)) {
        ({ value, time } = cache);
      }
    }
  }
  const { length } = value;
  if (!isValidBlackBox(value, options)) {
    reason = reason || (value ? 'td_box_too_long' : '');
    value = '';
  }
  if (read) {
    read.reason = reason;
    read.length = length;
    read.time = time;
    read.storageLength = storageLength;
  }
  return value;
};
